import { render } from "./SiteSummary.vue?vue&type=template&id=2b038aef&scoped=true"
import script from "./SiteSummary.vue?vue&type=script&lang=js"
export * from "./SiteSummary.vue?vue&type=script&lang=js"

import "./SiteSummary.vue?vue&type=style&index=0&id=2b038aef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b038aef"]])

export default __exports__